<span style="font-size:14px;font-weight:500;font-family:roboto;" mat-dialog-title>{{this.description}}</span>

<mat-dialog-content>

  <p> </p>
</mat-dialog-content>

<mat-dialog-actions>
  <button class="mat-raised-button" (click)="close()" style='text-align:center;'>Close</button>
</mat-dialog-actions>
